import React, { useMemo } from 'react'

const withPasswordValidation = WrappedComponent => {
  return props => {
    const { form, field } = props

    const password = form[field] || ''

    // Password requirements validation
    const requirements = useMemo(() => {
      return {
        length: {
          met: password.length >= 12,
          label: 'At least 12 characters long'
        },
        uppercase: {
          met: /[A-Z]/.test(password),
          label: 'Contains at least one uppercase letter (A-Z)'
        },
        lowercase: {
          met: /[a-z]/.test(password),
          label: 'Contains at least one lowercase letter (a-z)'
        },
        digit: {
          met: /[0-9]/.test(password),
          label: 'Contains at least one digit (0-9)'
        },
        special: {
          met: /[^A-Za-z0-9]/.test(password),
          label: 'Contains at least one special character (e.g., !@#$%^&*)'
        }
      }
    }, [password])

    // Check if all requirements are met
    const allRequirementsMet = useMemo(() => {
      return Object.values(requirements).every(req => req.met)
    }, [requirements])

    return (
      <WrappedComponent
        requirements={requirements}
        allRequirementsMet={allRequirementsMet}
        {...props}
      />
    )
  }
}

export default withPasswordValidation
